import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TrackingAdditionalPropertiesBuilder } from './tracking-additional-properties.builder';
import { TrackingObjectBuilder } from './tracking-object.builder';
import { TrackingBuilder } from './tracking.builder';
import { TrackingDispatcher } from './tracking.dispatcher';
import { TrackingEffects } from './tracking.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([TrackingEffects])],
})
export class TrackingModule {
  static forRoot(): ModuleWithProviders<TrackingModule> {
    return {
      ngModule: TrackingModule,
      providers: [
        TrackingDispatcher,
        TrackingBuilder,
        TrackingObjectBuilder,
        TrackingAdditionalPropertiesBuilder,
      ],
    };
  }
}
